import React from 'react'
import styled from '@emotion/styled'
export default function ControlBtn({ onIcon, offIcon, active, onChange }) {
  return (
    <Wrapper>
      <input
        type='checkbox'
        checked={active}
        onChange={onChange}
      />
      <span className='on'>{onIcon}</span>
      {offIcon && <span className='off'>{offIcon}</span>}
    </Wrapper>
  )
}

const Wrapper = styled.label`
  background: transparent;
  padding: 0.5rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
  fill: var(--text-white);
  transition: 0.3s all;
  :hover {
    background: var(--black-player-300);
  }
  span {
    line-height: 0;
  }
  .on {
    animation: keyframes-fill 0.5s;
  }

  .off {
    display: none;
    animation: keyframes-fill 0.5s;
  }

  input:checked ~ .on {
    display: none;
  }

  input:checked ~ .off {
    display: block;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  /* :focus-within {
    animation: keyframes-fill 0.3s;
  } */
  svg {
    cursor: pointer;
    width: 24px;
    fill: var(--text-white);
  }
  @keyframes keyframes-fill {
    0% {
      transform: rotate(-180deg) scale(0);
      opacity: 0;
    }

    50% {
      transform: rotate(-10deg) scale(1.2);
    }
  }
  * {
    cursor: pointer;
  }
`
